<template>
  <div class="notification">
    <div class="notification-container">
      <div v-if="toastNotifications()">
        <notification-toast
          v-for="notification in toastNotifications()"
          :key="notification.id"
          :notification="notification"
        />
      </div>
    </div>
    <notification-modal
      v-for="notification in modalNotifications()"
      :key="notification.id"
      :notification="notification"
    >
    </notification-modal>
    <notification-modal
      v-for="notification in refreshNotifications()"
      :key="notification.id"
      :notification="notification"
    >
    </notification-modal>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import { useStore } from 'vuex'

import { useRoute } from 'vue-router'

import { NOTIFICATION_TYPES } from '@/constants/constants.js'

const defaultNotificationType = NOTIFICATION_TYPES.TOAST

// #region - importing components
import NotificationModal from '@/components/NotificationModal'
import NotificationToast from '@/components/NotificationToast'
// endregion

// #region - store init
const store = useStore()
// endregion

// #region - set router
const route = useRoute()
// endregion

// #region - computed variables
const notifications = computed(() => store.state.notification.notifications)
// endregion

// #region - Method definitions
const updateSystemNotificationApproval = () => {
  const approvalStatus = notifications.value.length === 0
  store.commit('notificationPermission/UPDATE_SYSTEM_NOTIFICATION_APPROVAL', approvalStatus)
}

const toastNotifications = () => {
  return notifications.value.filter(notification => {
    if (notification.page_url) {
      return (
        typeof notification.kind === 'undefined' ||
        (notification.kind === defaultNotificationType && route.path.includes(notification.page_url))
      )
    } else {
      return typeof notification.kind === 'undefined' || notification.kind === defaultNotificationType
    }
  })
}
const modalNotifications = () => {
  updateSystemNotificationApproval()

  return notifications.value.filter(notification => {
    if (notification.page_url) {
      return notification.kind === NOTIFICATION_TYPES.MODAL && route.path.includes(notification.page_url)
    } else {
      return notification.kind === NOTIFICATION_TYPES.MODAL
    }
  })
}
const refreshNotifications = () => {
  return notifications.value.filter(notification => {
    if (notification.page_url) {
      return notification.kind === NOTIFICATION_TYPES.REFRESH && route.path.includes(notification.page_url)
    } else {
      return notification.kind === NOTIFICATION_TYPES.REFRESH
    }
  })
}
// endregion
</script>

<style lang="scss" scoped>
.notification {
  &-container {
    position: fixed;
    bottom: 20px;
    right: 40px;
    z-index: 9999;

    @media (max-width: 768px) {
      top: 18px;
      right: 18px;
      bottom: unset;
    }
  }
}
</style>
